export const locale = {
  en: {
    confirmText: "Confirm",
    placeholder: "",
    format: {
      date: "YYYY-MM-DD",
      datetime: "YYYY-MM-DD, hh:mm A",
      year: "YYYY",
      month: "MMMM",
      time: "hh:mm A",
      week: "w",
      months: {
        1: "January",
        2: "February",
        3: "March",
        4: "April",
        5: "May",
        6: "June",
        7: "July",
        8: "August",
        9: "September",
        10: "October",
        11: "November",
        12: "December"
      },
      days: {
        1: "Monday",
        2: "Tuesday",
        3: "Wednesday",
        4: "Thursday",
        5: "Friday",
        6: "Saturday",
        7: "Sunday"
      },
      first_day_of_week: "7"
    },
    shortcuts: {
      default: {
        today: "Today",
        yesterday: "Yesterday",
        tomorrow: "Tomorrow",
        week_ago: "One week ago",
        week_from_now: "Week from now",
        month_ago: "One month ago",
        month_from_now: "Month from now"
      },
      range: {
        today: "Today",
        this_week: "This week",
        this_month: "This month",
        this_year: "This year",
        last_week: "Last week",
        last_month: "Last month",
        next_week: "Next week",
        next_month: "Next month"
      }
    }
  },
  sl: {
    confirmText: "Potrdi",
    placeholder: "",
    format: {
      date: "DD. MM. YYYY",
      datetime: "DD. MM. YYYY, HH:mm",
      year: "YYYY",
      month: "MMMM",
      time: "HH:mm",
      week: "w",
      months: {
        1: "Januar",
        2: "Februar",
        3: "Marec",
        4: "April",
        5: "Maj",
        6: "Junij",
        7: "Julij",
        8: "Avgust",
        9: "September",
        10: "Oktober",
        11: "November",
        12: "December"
      },
      days: {
        1: "Ponedeljek",
        2: "Torek",
        3: "Sreda",
        4: "Četrtek",
        5: "Petek",
        6: "Sobota",
        7: "Nedelja"
      },
      first_day_of_week: "1"
    },
    shortcuts: {
      default: {
        today: "Danes",
        yesterday: "Včeraj",
        tomorrow: "Jutri",
        week_ago: "Pred 1 tednom",
        week_from_now: "Čez 1 teden",
        month_ago: "Pred 1 mesecem",
        month_from_now: "Čez 1 mesec"
      },
      range: {
        today: "Danes",
        this_week: "Tekoči teden",
        this_month: "Tekoči mesec",
        this_year: "Tekoče leto",
        last_week: "Pretekli teden",
        last_month: "Pretekli mesec",
        next_week: "Prihodnji teden",
        next_month: "Prihodnji mesec"
      }
    }
  }
}
